module.exports = __webpack_public_path__ + "assets/img/all1.b3ea1919.png";